<template>
  <div class="micro-product-card-wrapper">
    <img :src="product.thumbnail" alt="thumbnail" class="product-image" />
    <div class="content-wrapper">
      <div class="detail-wrapper">
        <p class="product-name">{{ product.name }}</p>
        <p class="product-price">฿{{ product.price }}</p>
      </div>
    </div>
    <button class="add-to-cart-btn" @click.stop="addToCart">{{ t('product.addToCart') }}</button>
  </div>
</template>


<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import router from '@/router'

export default {
  props: {
    product: {
      type: Object,
      default: () => null
    }
  },
  setup(props) {
    const store = useStore()
    const { t } = useI18n()
    const getUser = computed(() => store.getters['user/getUser'])
    const addToCart = () => {
      if (!getUser.value) {
        router.push('/user/login')
        return
      }
      store.dispatch('cart/fetchAddProduct', {
        product_id: props?.product?.id,
        quantity: 1,
        add_from: 'user',
        thumbnail: props?.product?.thumbnail,
        description: props?.product?.description,
        price: props?.product?.price,
        name: props?.product?.name,
      })
    }

    return {
      t,
      addToCart,
    }
  }
}
</script>

<style lang="scss" scoped>
.micro-product-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  cursor: pointer;
  padding-right: 8px;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.product-image {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  margin-right: 12px;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.detail-wrapper {
  font-size: 14px;
}

.product-price {
  color: #FD6868;
  font-weight: bold;
}

.add-to-cart-btn {
  padding: 6px 10px;
  font-size: 12px;
  background-color: #FD6868;
  color: white;
  border: none;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 12px;
}
</style>
